import React, { useContext } from "react";
import { Router } from "@reach/router";
import SignIn from "./SignIn";
import MainPage from "./MainPage.js";
import { UserContext } from "./UserProvider";

function App() {
  const user = useContext(UserContext);

  return user ? (
    <MainPage />
  ) : (
    <Router>
      <SignIn path="/" />
    </Router>
  );
}
export default App;
